import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DocumentTag, DocumentTagCreate, DocumentTagFilter } from '../data/documentTag';

export function createDocumentTagService(client: AxiosInstance) {
  return createCrudService<DocumentTag, DocumentTagCreate, DocumentTagFilter>(
    client,
    '/document-management/DocumentTag',
    'id',
  );
}

export type DocumentTagService = CrudService<DocumentTag, DocumentTagCreate, DocumentTagFilter>;
